module.exports = __webpack_public_path__ + "static/media/sopt27kz.ead2e386.pdf";